<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const resultsStepRoutes = new Set(["results", "calc"]);
const currentStep = computed(() =>
  resultsStepRoutes.has(String(route.name ?? "")) ? 2 : 1
);
</script>

<template>
  <div
    class="dashboard-page flex h-full flex-col overflow-hidden bg-transparent"
  >
    <div
      class="content flex min-h-0 flex-1 flex-col overflow-visible bg-transparent"
    >
      <nav
        class="hidden shrink-0"
        :style="{ backgroundColor: 'var(--dashboard-workflow-step-bg)' }"
      >
        <div
          class="mx-auto flex max-w-7xl items-center justify-center gap-0 px-2 pt-4 pb-1 md:px-8 md:pt-6 md:pb-2"
        >
          <div
            class="relative flex items-center gap-2 px-2 py-2 text-xs font-medium md:px-5 md:py-2.5 md:text-sm"
            :class="currentStep === 2 ? 'text-[#234984]' : 'text-slate-400'"
          >
            <span
              class="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-[13px] font-bold text-white"
              :class="currentStep === 2 ? 'bg-[#234984]' : 'bg-slate-300'"
            >
              2
            </span>
            <span>Results</span>
          </div>
        </div>
      </nav>
      <div class="flex min-h-0 flex-1 flex-col">
        <RouterView />
      </div>
    </div>
  </div>
</template>
